import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import theme from '~/truck/theme'
import { getTextStyle } from '~/truck/utils'

export const Name = styled.li`
  margin-bottom: ${theme.spacing.cozy}px;

  ${getTextStyle('h5Bold')};
`

export const Content = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-column-gap: ${theme.spacing.cozy}px;
  grid-row-gap: ${theme.spacing.cozy}px;
  grid-template-columns: 1fr;

  ${up('lg')} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`
